import React from 'react';

import './page.css';

//
import MainTitle from '../../components/page/main-title/MainTitle';

// import route Components here
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch,
  Redirect
} from 'react-router-dom';
import { Pie, Line } from 'react-chartjs-2';
import DateRangePickerWrapper from "../../components/form/DateRangePickerWrapper";
import Button from '../../components/buttons/Button';

import STRINGS from './../../data/language/language';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Dialog from '../../components/alert/Dialog';

const DEFAULT = {
  compras_boleto: '',
  compras_cartao: '',
  novas_adesoes: '',
  graphic: {
    line: [],
    pizza: []
  }
};

class Dashboard extends React.Component{
  constructor (props){
    super(props);

    const date = new Date();
    let firstDay = 1 +'/'+  (date.getMonth()+1) +'/'+  date.getFullYear();
    let today = date.getDate() +'/'+  (date.getMonth()+1) +'/'+  date.getFullYear();

    this.state = {
      strings:STRINGS[window.LANGUAGE],
      lista: [],
      data: DEFAULT,
      fem: DEFAULT,
      masc: DEFAULT,
      isLoading: true,
      dataInicial: firstDay,
      dataFinal: today
    }

    this.handleSubmit = this.handleSubmit.bind(this);

  }

  componentDidMount() {
    window.scrollTo(0, 0);

    const {atencao} = this.state.strings;
    let _self = this;

    Requisitions({
      url: WS.dashboard.load,
      data:{},
      sucess:function(data){
        _self.setState({
          isLoading: false,
          data: data.geral,
          fem: data.f,
          masc: data.m
        });
      },
      error:function(data){
        console.log(data);
      }
    });
  }

  loadData(_args_) {
    const {atencao} = this.state.strings;
    let _self = this;

    Requisitions({
      url: WS.dashboard.load,
      data:_args_,
      sucess:function(data){
        _self.setState({
          isLoading: false,
          data: data.geral,
          dataInicial: _args_.dti,
          dataFinal: _args_.dtf,
          fem: data.f,
          masc: data.m
        });
      },
      error:function(data){
        console.log(data);
      }
    });
  }

  handleSubmit(e){
    const form = document.getElementById('form-data-adesao');
    const dti = form.querySelectorAll("[name='dti']")[0].value;
    const dtf = form.querySelectorAll("[name='dtf']")[0].value;
    this.loadData({dti, dtf});
    e.preventDefault();
  }

  getPage(){

    const pizza = this.state.data.graphic.pizza.map((value, i) =>
        Number(value)
      );

    const dataPie = {
        datasets: [{
            data: pizza,
            backgroundColor: [
                  '#ff6384',
                  '#36a2eb'
              ]
        }],
        // These labels appear in the legend and in the tooltips when hovering different arcs
        labels: [
            'Cartão',
            'Boleto'
        ]
    };

    const arrDays = [];
    const arrPassado = [];// this.state.data.graphic.line.old;
    const arrAtual = [];//this.state.data.graphic.line.current;

    const old = this.state.data.graphic.line.old;
    const atual = this.state.data.graphic.line.current;

    for (var key in old) {
      if (old.hasOwnProperty(key)) {
          arrPassado.push(old[key]);
      }
    }

    for (var key in atual) {
      if (atual.hasOwnProperty(key)) {
          arrAtual.push(atual[key]);
          arrDays.push(key);

      }
    }

		var dataLine = {
      labels: arrDays,
      datasets: [
          {
            data: arrPassado,
            label: "Mês passado",
            borderColor: "#3e95cd",
            backgroundColor: 'rgba(64,148,255, .1)',
            borderWidth:1.5
          }, {
            data: arrAtual,
            label: "Mês atual",
            borderColor: "#FF395F",
            backgroundColor: 'rgba(255,57,95, .1)',
            borderWidth: 1.5,
            borderDash: [6]
          }
        ]
		};

    const pizzaBox = (pizza[0] === 0 && pizza[1] === 0) ? <div>Nenhum dado disponível</div> : <Pie data={dataPie} />;

    return(
      <div>
        <div className='mini-banner-box'>
          <div className="pure-g">
            <div className="pure-u-1 pure-u-md-8-24">
              <div className="mini-banner">
                <div className="mini-banner__box mini-banner__box-blue">
                  <div className="mini-banner__inner">
                    <div className='mini-banner__title'>Novas adesões</div>
                    <div>
                      <div className='mini-banner__value f-left'>{this.state.data.novas_adesoes}</div>
                      <div className='f-right sexo-box-report'>
                        <div className='f-left'>
                          <i className="fas fa-female"></i>
                          <span>{this.state.fem.novas_adesoes}</span>
                        </div>
                        <div className='f-left'>
                          <i className="fas fa-male"></i>
                          <span>{this.state.masc.novas_adesoes}</span>
                        </div>
                        <div className='clear'></div>
                      </div>
                      <div className='clear'></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="pure-u-1 pure-u-md-8-24">
              <div className="mini-banner">
                <div className="mini-banner__box mini-banner__box-yellow">
                  <div className="mini-banner__inner">
                    <div className='mini-banner__title'>Compras cartão</div>
                      <div>
                        <div className='mini-banner__value f-left'>{this.state.data.compras_cartao}</div>
                        <div className='f-right sexo-box-report'>
                          <div className='f-left'>
                            <i className="fas fa-female"></i>
                            <span>{this.state.fem.compras_cartao}</span>
                          </div>
                          <div className='f-left'>
                            <i className="fas fa-male"></i>
                            <span>{this.state.masc.compras_cartao}</span>
                          </div>
                          <div className='clear'></div>
                        </div>
                        <div className='clear'></div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="pure-u-1 pure-u-md-8-24">
              <div className="mini-banner">
                <div className="mini-banner__box mini-banner__box-green">
                  <div className="mini-banner__inner">
                    <div className='mini-banner__title'>Compas boleto</div>
                      <div>
                        <div className='mini-banner__value f-left'>{this.state.data.compras_boleto}</div>
                        <div className='f-right sexo-box-report'>
                          <div className='f-left'>
                            <i className="fas fa-female"></i>
                            <span>{this.state.fem.compras_boleto}</span>
                          </div>
                          <div className='f-left'>
                            <i className="fas fa-male"></i>
                            <span>{this.state.masc.compras_boleto}</span>
                          </div>
                          <div className='clear'></div>
                        </div>
                        <div className='clear'></div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="pure-g">
          <div className="pure-u-1 pure-u-md-10-24">
            <div className='graph-pizza'>
              <span className='title-graph'>Compras</span>
              {pizzaBox}
            </div>
          </div>
          <div className="pure-u-1 pure-u-md-14-24">
            <span className='title-graph'>Adesões</span>
            <Line data={dataLine} />
          </div>
        </div>
      </div>

    );
  }

  render() {


    const data = window.localStorage.getItem('loginData');
    let page = <div></div>;

    if(data){
      const dataObj = JSON.parse(data);
      const permissions = dataObj.permissions;

      if(permissions['dashboard']){
        page = this.getPage();
      }
    }

    const { dataInicio, dataFim, procurar } = this.state.strings;
    var date = new Date();
    var timestamp = date.getTime();

    return (
      <div className="page-dashboard" >
        <div className="container">
          <div className="container-box">
            <div className="container-box--inner">
              <MainTitle title="Dashboard"></MainTitle>
                <div className=''>
                <form onSubmit={this.handleSubmit} id="form-data-adesao">
                  <div className="pure-u-9-24">
                  <DateRangePickerWrapper
                    key={timestamp}
                     dti={this.state.dataInicial}
                     dtf={this.state.dataFinal}
                     titleDateInicio={dataInicio}
                     titleDateFim={dataFim} />
                  </div>
                  <div className="pure-u-9-24">
                    <div className='box-button-search-date'><Button type="submit" text={procurar} classes="bt-save bt-blue" /></div>
                  </div>
                  <br /><br />
                  </form>
                </div>
              {page}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/classes/dashboard/Dashboard.js